import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import H5 from 'syf-component-library/ui/typography/H5';
import { Stack } from 'syf-component-library/ui/spacing';
import { translate } from '../../../../strings/i18n';
import { NoManageCardHoldersAddedContainer } from './subcomponents';
const NoManageCardHoldersAdded = () => {
    return (_jsxs(NoManageCardHoldersAddedContainer, { top: "large", hideOnBreakpointDown: "medium", "data-testid": "authorized-users__no-data", "data-cy": "message-box-container", children: [_jsx(Stack, { size: "small", hideOnBreakpointUp: "medium", "data-testid": "authorized-users__no-data", "data-cy": "message-box-container" }), _jsx(H5, { weight: "bold", children: translate('noAccountAddedMessage') })] }));
};
export default NoManageCardHoldersAdded;
